import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const ApplicationId = pipe(
	string,
	parse((s) => (s.startsWith(`application:`) ? success(s) : failure(s, 'Invalid application id')))
);
